@let asyncContext = { period: period$ | async };
<ui-section
    [title]="config.translations.widgetTitle + ' (€' + ('STUFF.' + vatModeForTranslations | translate) + ')'"
    [subtitle]="
        asyncContext.period === lastTwelveMonths
            ? ('WIDGET.PERIOD_TWELVE_MONTHS' | translate)
            : asyncContext.period
              ? ('WIDGET.PERIOD_YEAR' | translate: { year: asyncContext.period | translatePeriod })
              : ''
    "
>
    <ui-section-actions>
        @if (dataSource?.length > 0) {
            <ui-icon-button
                color="primary"
                iconName="export-spreadsheet"
                class="no-print"
                item-end
                [advizeoTooltip]="'CSV_EXPORT.MOUSEHOVER' | translate"
                (click)="exportDataAsCsv()"
            />

            <button
                type="button"
                ui-button
                item-end
                color="primary"
                iconName="go-to"
                buttonStyle="outline"
                size="small"
                class="no-print"
                (click)="goToBillsByBuilding()"
            >
                {{ 'WIDGET.WATCH_BALANCE' | translate }}
            </button>
        }
    </ui-section-actions>
    <ui-section-content>
        @if (dataSource?.length > 0 && !isLoading && !loadingError) {
            <ui-table class="width-100" [dataSource]="dataSource">
                <!-- type Column (universe icon) -->
                <ng-container uiColumnDef="type" size="0.5">
                    <ui-header-cell *uiHeaderCellDef />
                    <ui-cell *uiCellDef="let universeData; let i = index">
                        <ui-avatar shape="circle" size="small" [src]="universeData.universeName | universeImage" />
                    </ui-cell>
                </ng-container>
                <!-- universe Column -->
                <ng-container uiColumnDef="universe">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.BUDGET_BALANCE_TABLE.UNIVERSE' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index">
                        @if (!universeData.isTotal) {
                            <span>{{ universeData.universeName | referenceListLabel: 'universe' }}</span>
                        } @else {
                            <span class="text-strong">Total</span>
                        }
                    </ui-cell>
                </ng-container>
                <!-- actualConsumption Column -->
                <ng-container uiColumnDef="actualConsumption">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.BUDGET_BALANCE_TABLE.ACTUAL_CONSUMPTION' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index">
                        @if (!universeData.isTotal && formatters.targetUnitsFormatters[universeData.consumptionIndicator]) {
                            <span>
                                {{
                                    universeData.energyDataCurrentPeriod
                                        | applyPureFunction: formatters.targetUnitsFormatters[universeData.consumptionIndicator]
                                }}
                            </span>
                        }
                    </ui-cell>
                </ng-container>
                <!-- invoicedAmount Column -->
                <ng-container uiColumnDef="invoicedAmount">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.BUDGET_BALANCE_TABLE.INVOICED_AMOUNT' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index" [class.text-strong]="universeData.isTotal">
                        {{ universeData.budgetDataCurrentPeriod?.recorded | localnumbercurrency: 'EURO' : 0 : 0 }}
                    </ui-cell>
                </ng-container>
                <!-- estimatedAmount Column -->
                <ng-container uiColumnDef="estimatedAmount">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.BUDGET_BALANCE_TABLE.ESTIMATED_AMOUNT' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index" [class.text-strong]="universeData.isTotal">
                        {{ universeData.budgetDataCurrentPeriod?.estimated | localnumbercurrency: 'EURO' : 0 : 0 }}
                    </ui-cell>
                </ng-container>
                <!-- unitPrice Column -->
                <ng-container uiColumnDef="unitPrice">
                    <ui-header-cell *uiHeaderCellDef>
                        {{ 'WIDGET.BUDGET_BALANCE_TABLE.UNIT_PRICE' | translate }}
                        <help-me class="no-print" [text]="'WIDGET.BUDGET_BALANCE_TABLE.UNIT_PRICE_HELP' | translate" />
                    </ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index">
                        @if (
                            !universeData.isTotal &&
                            universeData.unitPriceCurrentPeriod &&
                            formatters.unitPriceFormatters[universeData.consumptionIndicator]
                        ) {
                            <div>
                                <div>
                                    {{
                                        universeData.unitPriceCurrentPeriod
                                            | applyPureFunction: formatters.unitPriceFormatters[universeData.consumptionIndicator]
                                    }}
                                </div>
                                @if (universeData.unitPriceEvolutionRatio) {
                                    <div
                                        class="text-strong"
                                        [coloredTextColor]="
                                            (universeData.unitPriceEvolutionRatio | significantDigits) <= 0 ? 'success' : 'failure'
                                        "
                                    >
                                        ({{
                                            universeData.unitPriceEvolutionRatio * 100 | significantDigits | localnumber: 1 : 0 : 3 : true
                                        }}
                                        %)
                                    </div>
                                }
                            </div>
                        }
                    </ui-cell>
                </ng-container>
                <!-- budgetGap Column -->
                <ng-container uiColumnDef="budgetGap">
                    <ui-header-cell *uiHeaderCellDef>
                        {{ 'WIDGET.BUDGET_BALANCE_TABLE.BUDGET_GAP' | translate }}
                        @if (!ignoreEstimated) {
                            <help-me class="no-print" [text]="'WIDGET.BUDGET_BALANCE_TABLE.INCLUDES_ESTIMATED' | translate" />
                        }
                    </ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index" [class.text-strong]="universeData.isTotal">
                        @if (universeData.budgetGapCurrentPeriod) {
                            <div>
                                <div>
                                    {{ formatters.budgetGapFormatter(universeData.budgetGapCurrentPeriod) }}
                                </div>
                                @if (universeData.budgetGapRatio) {
                                    <div
                                        class="text-strong"
                                        [coloredTextColor]="(universeData.budgetGapRatio | significantDigits) <= 0 ? 'success' : 'failure'"
                                    >
                                        ({{ universeData.budgetGapRatio * 100 | significantDigits | localnumber: 1 : 0 : 3 : true }}%)
                                    </div>
                                }
                            </div>
                        }
                    </ui-cell>
                </ng-container>
                <!-- pricePerSurfaceUnit Column -->
                <ng-container uiColumnDef="pricePerSurfaceUnit">
                    <ui-header-cell *uiHeaderCellDef>
                        {{
                            'WIDGET.BUDGET_BALANCE_TABLE.PRICE_PER_SURFACE_UNIT'
                                | translate: { currency: currencyBaseUnitCode | referenceListLabel: 'unit', surfaceUnit: surfaceUnit }
                        }}
                        @if (!ignoreEstimated) {
                            <help-me class="no-print" [text]="'WIDGET.BUDGET_BALANCE_TABLE.INCLUDES_ESTIMATED' | translate" />
                        }
                    </ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index" [class.text-strong]="universeData.isTotal">
                        @if (universeData.pricePerSurfaceUnit !== null && universeData.pricePerSurfaceUnit !== undefined) {
                            <span>
                                {{ universeData.pricePerSurfaceUnit | localnumber: -1 : 2 : 2 }}
                                {{
                                    'WIDGET.BUDGET_BALANCE_TABLE.PRICE_PER_SURFACE_UNIT'
                                        | translate
                                            : { currency: currencyBaseUnitCode | referenceListLabel: 'unit', surfaceUnit: surfaceUnit }
                                }}
                            </span>
                        }
                    </ui-cell>
                </ng-container>
                <ui-header-row *uiHeaderRowDef="headers$ | async" />
                <ui-row *uiRowDef="let universeData; columns: headers$ | async" />
            </ui-table>
        }
        @if (isLoading || loadingError || dataSource?.length === 0) {
            <loading-and-error
                padding
                [isLoading]="isLoading"
                [hasError]="loadingError"
                [hasNoData]="dataSource?.length === 0"
                [noDataTitle]="'PAGES.BUILDING_HOME.ENERGY_BALANCES.NO_ENERGY_BALANCE_TITLE' | translate"
                [noDataMessage]="'PAGES.BUILDING_HOME.ENERGY_BALANCES.NO_ENERGY_BALANCE_SUBTITLE' | translate"
            />
        }
    </ui-section-content>
</ui-section>
